import 'dayjs/locale/zh-cn'

import dayjs from 'dayjs'
import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
dayjs.locale('zh-cn')

interface Props {
  onChange: (t: string) => void
}
interface daysType {
  week: string
  day: string
  date: string
}
export default ({ onChange }: Props) => {
  const [next, setNext] = useState(false)
  const [nowDate, setNowDate] = useState<string[]>([])
  const [days, setDays] = useState<daysType[]>([])
  const [active, setActive] = useState('')
  const [activeLeft, setActiveLeft] = useState(0)

  useEffect(() => {
    // 取服务端时间
    const nowDay = dayjs()
    const today = nowDay.format('DD')
    setNowDate([nowDay.format('YYYY'), nowDay.format('MM'), nowDay.format('DD')])
    setActive(nowDay.format('YYYY-MM-DD'))
    const firstDay = nowDay.startOf('week')
    const weekDays = []
    let symbol = 0
    for (let index = 0; index < 14; index++) {
      const day = firstDay.add(index, 'day')
      if (day.format('DD') === today) {
        symbol = index
      }
      weekDays.push({
        week: day.format('ddd'),
        day: day.format('DD') === today ? '今' : day.format('DD'),
        date: day.format('YYYY-MM-DD')
      })
    }
    setDays(weekDays)
    // 宽度固定，所以写死计算基数
    setActiveLeft(symbol * 104 + 24)
  }, [])

  const select = (date: string) => {
    setActive(date)
  }

  useEffect(() => {
    if (days.length) {
      if (next) {
        setActive(days[7].date)
      } else {
        setActive(days[0].date)
      }
    }
  }, [next])

  useEffect(() => {
    onChange(active)
    if (days.length) {
      let symbol = 0
      days.forEach((item, i) => {
        if (item.date === active) {
          symbol = i >= 7 ? i - 7 : i
        }
      })
      setActiveLeft(symbol * 104 + 24)
    }
  }, [active])

  return (
    <React.Fragment>
      <Title className="w-[140px] flex flex-col justify-center items-center text-[18px] text-[#333]">
        <div>{nowDate[0]}年</div>
        <div>{nowDate[1]}月</div>
      </Title>
      <Container className="week h-[56px] flex-1 flex justify-center items-center rounded-full bg-[#f7f7f7] ">
        <div className={`h-full w-[56px] flex justify-center items-center cursor-pointer ${next ? 'text-[#ff3300]' : 'cursor-no-drop'}`} onClick={() => setNext(false)}>
          <AiOutlineLeft className="text-[20px]" />
        </div>
        <div className="flex-1 h-full overflow-hidden relative">
          <div className="day-style w-[56px] h-[56px] rounded-md absolute" style={{ left: activeLeft }}></div>
          <div className={`week-cont w-[200%] h-full flex justify-around items-center absolute ${next ? 'left-[-100%]' : 'left-0'}`}>
            {days.map((item, i) => (
              <div
                key={i}
                onClick={() => select(item.date)}
                className={`text-center h-full flex flex-col justify-center items-center w-[56px] cursor-pointer rounded-md ${active === item.date ? '' : 'hover:bg-[#e9e9e9]'}`}
              >
                <div className={`txt-style w-full text-[14px] ${active === item.date ? 'text-[#FFF]' : 'text-[#333333]'}`}>{item.week}</div>
                <div className={`txt-style w-full text-[18px] ${active === item.date ? 'text-[#FFF]' : 'text-[#333333]'}`}>{item.day}</div>
              </div>
            ))}
          </div>
        </div>
        <div className={`h-full w-[56px] flex justify-center items-center cursor-pointer ${next ? 'cursor-no-drop' : 'text-[#ff3300]'}`} onClick={() => setNext(true)}>
          <AiOutlineRight className="text-[20px]" />
        </div>
      </Container>
    </React.Fragment>
  )
}

const Title = styled(motion.div)``
const Container = styled(motion.div)`
  box-shadow:
    rgb(204, 219, 232) 3px 3px 6px 0px inset,
    rgba(255, 255, 255, 0.5) -3px -3px 6px 1px inset;
  .week-cont {
    transition: all 0.5s;
  }
  .txt-style {
    transition: all 0.5s;
  }
  .day-style {
    background: linear-gradient(39deg, #ff742f 0%, #ff3300 100%);
    transition: all 0.5s;
    box-shadow:
      rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  }
`
